import type { CreateRequestFn } from '../types';

export const createRequest: CreateRequestFn =
    process.env.BUILD_TARGET === 'client'
        ? require('./createClientRequest').createClientRequest
        : require('./createServerRequest').createServerRequest;
